const miqFlashClear = () => {
  document.getElementById('flash_msg_div').text = '';
};

export default miqFlashClear;
